import React, { useEffect, useState } from "react";
import { UiComponents } from "@simulanisindia/ui";
import PermissionCard from "./PermissionCard";
import PermissionHeader from "./PermissionHeader";
import { removeDuplicatesValue, removeMatchedValues } from "../../../utils/general";
import NoDataFound from "../../NoDataFound";

const Permissions = ({
  onlyView = false,
  isMobileView = true,
  heading,
  roleId,
  description,
  permissions,
  selectPermissions,
  setSelectPermissions,
}) => {
  const { SimCheckBox } = UiComponents;
  const [permissionList, setPermissionList] = useState({});
  const [allPermissionIds, setAllPermissionIds] = useState([]);
  const [checked, setChecked] = useState(false);
  const [search, setSearch] = useState("");

  useEffect(() => {
    setPermissionList(permissions);
    let allIds = permissions?.children?.map((e) => e.children.map((child) => child.id)).flat(Infinity) || [];
    setAllPermissionIds(allIds);
  }, [permissions]);

  const handleSelectAllTabPermission = (e) => {
    if (e.target.checked) {
      let allPermissions = [...selectPermissions, ...allPermissionIds];
      setSelectPermissions(removeDuplicatesValue(allPermissions));
    } else {
      setSelectPermissions(removeMatchedValues(selectPermissions, allPermissionIds));
    }
  };

  useEffect(() => {
    setChecked(allPermissionIds.length === 0 ? false : allPermissionIds.every((e) => selectPermissions.includes(e)));
  }, [allPermissionIds, selectPermissions]);

  return (
    <>
      <div id={roleId} className="role-permissions">
         <PermissionHeader search={search} setSearch={setSearch} />
        <div className="colorborder">
          <div className="common-list">
            <div className="common-list-header">
              <div className="common-list-heading">
                <h6> {heading}</h6>
                <p>Select the {description} permissions you want to assign to the role</p>
              </div>
              {allPermissionIds.length > 0 && (
                <div className="d-flex gap-2">
                  <SimCheckBox disabled={onlyView} checked={checked} onChange={handleSelectAllTabPermission} />
                  <p>All Permissions</p>
                </div>
              )}
            </div>

            {permissionList?.children?.length > 0 ? (
              <div className="common-card-list">
                {permissionList?.children
                  ?.filter((item) => item.children.length > 0)
                  .map((item, index) => (
                    <PermissionCard
                      onlyView={onlyView}
                      key={index}
                      search={search}
                      heading={item.displayName}
                      permissions={item.children}
                      selectPermissions={selectPermissions}
                      setSelectPermissions={setSelectPermissions}
                    />
                  ))}
              </div>
            ) : (
              <NoDataFound headText="No data found" />
            )}

            {/* <div className="common-card-list">
                            {permissionList?.children?.filter(item => item.children.length > 0).map((item, index) => (
                                <PermissionCard
                                    key={index}
                                    search={search}
                                    heading={item.displayName}
                                    permissions={item.children}
                                    selectPermissions={selectPermissions}
                                    setSelectPermissions={setSelectPermissions}
                                />
                            ))}
                        </div> */}
          </div>
        </div>
      </div>
    </>
  );
};

export default Permissions;
